import { ready } from '~/core'

ready('body_outline', 'body', body => {
	body.addEventListener('mousedown', function () {
		body.classList.add('is-usingMouse');
	});
	body.addEventListener('keydown', function () {
		body.classList.remove('is-usingMouse');
	});

	// Hides empty widget zones on pages so whitespace with borders aren't rendered.
	$('.section-inner').each(function() {
		let $this = $(this);
		if ($this.text().trim() === '') {
			$this.html('');
		}
	});

	const sidebar = document.querySelector('.pageCols-rail');
	if (sidebar) {
		const pageCols = document.querySelector('.pageCols');
		const sidebarNav = sidebar.querySelector('.navSecondary');
		const breakpoint = getComputedStyle(body).getPropertyValue('--breakLg');
		const pageIsTallEnough = pageCols.offsetHeight > sidebarNav.offsetHeight * 1.5;

		const attemptToStickSidebar = () => {
			let currentLeft = sidebarNav.getBoundingClientRect().left;
			let isPastSidebarStickThreshold = window.scrollY > sidebar.getBoundingClientRect().top;
			let headerBottom = document.querySelector('.headerMain').getBoundingClientRect().bottom;
			let headerNavHeight = document.querySelector('.headerMain').offsetHeight;
			let sidebarNavWidth = sidebarNav.offsetWidth;
			let sidebarBottom = sidebar.getBoundingClientRect().bottom;
			let sidebarNavHeight = sidebarNav.offsetHeight;
			if (window.innerWidth >= parseInt(breakpoint) && isPastSidebarStickThreshold && pageIsTallEnough) {
				sidebar.classList.add('is-sticky');

				if (sidebarBottom - headerBottom < sidebarNavHeight) {
					sidebarNav.style.position = 'absolute';
					sidebarNav.style.top = 'auto';
					sidebarNav.style.left = '0';
					sidebarNav.style.bottom = '0';
					sidebarNav.style.width = `${sidebarNavWidth}px`;
				} else {
					sidebarNav.style.position = 'fixed';
					sidebarNav.style.left = `${currentLeft}px`;
					sidebarNav.style.top = `${headerNavHeight}px`;
					sidebarNav.style.bottom = 'auto';
					sidebarNav.style.width = `${sidebarNavWidth}px`;
					sidebarNav.style.marginBottom = "0px";
				}
			} else {
				sidebar.classList.remove('is-sticky');
				sidebarNav.style.position = 'static';
				sidebarNav.style.left = 'auto';
				sidebarNav.style.top = 'auto';
				sidebarNav.style.bottom = 'auto';
				sidebarNav.style.width = 'auto';
			}
		}

		window.addEventListener('scroll', function () {
			attemptToStickSidebar();
		});

		// throttled resize window listener
		let resizeTimer;
		window.addEventListener('resize', function () {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				attemptToStickSidebar();
			}, 50);
		});
	}
});